const week = [
  { value: 0, label: 'Sonntag' },
  { value: 1, label: 'Montag' },
  { value: 2, label: 'Dienstag' },
  { value: 3, label: 'Mittwoch' },
  { value: 4, label: 'Donnerstag' },
  { value: 5, label: 'Freitag' },
  { value: 6, label: 'Samstag' },
];

import React from 'react';
import Select from './Select';

class SelectWeek extends Select {

  constructor(props) {
    super(props);
    this.renderOptions = this.renderOptions.bind(this);
  }

  renderOptions() {
    return week.map((option) => {
      return (
        <option
          value={option.value}
          key={`${this.props.controlId}_${option.label}`}
        >
          {option.label}
        </option>
      );
    })
  }
}

export default SelectWeek;



/** WEBPACK FOOTER **
 ** ./src/form/SelectWeek.js
 **/